import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  GetCoilWidths,
  CreateCoilWidth,
  UpdateCoilWidth,
  DeleteCoilWidth,
} from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { DEFAULT_STALE_TIME } from "../Constant/AppConstants";

export const coilWidthQueryKeys = {
  all: ["coilWidths"] as const,
};

export const useCoilWidthsQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    ...options,
    queryKey: coilWidthQueryKeys.all,
    queryFn: async () => unwrapApiResponse(await GetCoilWidths()),
  });
};

export const useCreateCoilWidthMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateCoilWidth>[0]) =>
      CreateCoilWidth(payload),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({ queryKey: coilWidthQueryKeys.all });
      }
    },
  });
};

export const useUpdateCoilWidthMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateCoilWidth>[0]) =>
      UpdateCoilWidth(payload),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({ queryKey: coilWidthQueryKeys.all });
      }
    },
  });
};

export const useDeleteCoilWidthMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => DeleteCoilWidth(id),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({ queryKey: coilWidthQueryKeys.all });
      }
    },
  });
};
